module.exports = __webpack_public_path__ + "img/icon4.80274cd2.png";